import { ProductBundleSettingsBuilder } from "../builders/product.bundle.builder";
import { BundleItem } from "./bundle-item";

export class ProductBundleSettings {
  public readonly items: BundleItem[];
  constructor(builder: ProductBundleSettingsBuilder) {
    this.items = builder.items;
  }

  toJSON() {
    return {
      items: this.items == null ? null : this.items.map(item => item.toAPIRequest())
    };
  }
}
